import React, { Component } from 'react';
import { Link } from 'react-router';
import 'bootstrap/dist/css/bootstrap.css';
import '../css/trimmis.scss';

export default class FacebookPageEmbed extends Component {

    constructor(props) {
        super(props);
        this.state = {
            scriptLoaded: false
        };
    }

    render() {
        return (
            <div className="fb-page hidden-xs hidden-sm content-margin-20" data-href={this.props.pageUrl}
                 data-tabs="timeline" data-small-header="true" data-adapt-container-width="true"
                 data-hide-cover="true" data-show-facepile="false" data-height="615">
                <blockquote cite={this.props.pageUrl} className="fb-xfbml-parse-ignore">
                    <Link to={this.props.pageUrl}>{this.props.name}</Link>
                </blockquote>
            </div>
        );
    }

    componentDidMount() {
        if(!this.state.scriptLoaded) {
            const fbJs = document.createElement('script');
            fbJs.async = false;
            fbJs.src = "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.8";
            document.getElementsByTagName('body')[0].appendChild(fbJs);
            const fbDiv = document.createElement('div');
            fbDiv.id = "fb-root";
            document.getElementsByTagName('body')[0].appendChild(fbDiv);
            this.setState({
                scriptLoaded: true
            });
        }
    }
}



// WEBPACK FOOTER //
// ../components/FacebookPage.js